import { Stack, Typography, useTheme } from "@mui/material";
import { Lock } from "lucide-react";
import type { FC } from "react";
import { ALLOCATION_MIN } from "web_myplann/Goals/constants";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

type Props = {
	isFull: boolean;
	available: number;
	pinnedAllocation: number | null;
};

export const PinExistingContractItemStatus: FC<Props> = ({
	isFull,
	available,
	pinnedAllocation,
}) => {
	const { spacingTokens } = useTheme();
	const { t } = useResource();

	if (isFull) {
		return (
			<Stack
				direction="row"
				alignItems="center"
				gap={spacingTokens.xs}
				color="error.main"
			>
				<Lock size={12} />
				<Typography variant="button" color="inherit">
					{t(Resources.Goals.Detail.Solution.Pin.Existing.fullyAllocated, {
						percent: available,
						min: ALLOCATION_MIN,
					})}
				</Typography>
			</Stack>
		);
	}

	if (pinnedAllocation !== null) {
		return (
			<Typography variant="button" color="blue.600" tabular>
				{t(Resources.Goals.Detail.Solution.Pin.Existing.alreadyPinned, {
					percent: pinnedAllocation,
				})}
			</Typography>
		);
	}

	return (
		<Typography variant="caption" color="grey.500" tabular>
			{t(Resources.Goals.Detail.Solution.Pin.Existing.available, {
				percent: available,
			})}
		</Typography>
	);
};
